import { CSVDownloader, CSVReader, readString } from "react-papaparse";
import { Consumer, Context, Provider } from "./components/SettingsContext";
import DisplayHours, { DisplayHoursRaw } from "./components/DisplayHours";
import React, { createContext, useContext, useState, useEffect } from "react";
import {
  bold,
  buttonCont,
  content,
  daterange,
  daterangeheader,
  detail,
  detail_row,
  downloadAsPdf,
  dr,
  drCont,
  dropzone,
  flipActive,
  flipButton,
  flipButtonAnchor,
  flipContainer,
  header,
  littleRow,
  logo,
  padding,
  page,
  reloadButton,
  row_col_hours,
  row_col_site_name,
  row_edges,
  rowsCont,
  searchBox,
  title,
  titleRow,
  titleRowTable,
  titleright,
  upload,
} from "./pages/index.module.css";
import {
  row,
  row_col,
  row_main,
  row_site,
  row_title,
  row_value,
} from "./components/row.module.css";

import DataExport from "./components/dataExport";
import Fuse from "fuse.js";
import MyDropzone from "./components/MyDropzone";
import Row from "./components/Row";
import Settings from "./components/Settings";
import createPDF from "./pdf";
import moment from "moment";
import { markOverlappingTimesheetRows } from "./timesheet-overlap";
import { useRouter, useTerminology } from "utils";
import { connect } from "react-redux";
import { timesheetReportFetch } from "features/account/actions";
import { sortByPropertyAlphabetically } from "utils";
import { SelectInput } from "frame/components";
import { DayPickerRangeController } from "react-dates";
import "react-dates/initialize";
import "react-dates/lib/css/_datepicker.css";
import { Grid, Typography, Button, withStyles, CircularProgress, Collapse, IconButton, Tooltip } from "@material-ui/core";
import { makeStyles } from "@material-ui/styles";
import ChevronLeftIcon from "@material-ui/icons/ChevronLeft";
import ChevronRightIcon from "@material-ui/icons/ChevronRight";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import ExpandLessIcon from "@material-ui/icons/ExpandLess";
import UnfoldMoreIcon from "@material-ui/icons/UnfoldMore";
import FilterListIcon from "@material-ui/icons/FilterList";

const axios = require("axios");
const ers_all = ["Invalid time range", "Invalid staff member"];
const queryString = require("query-string");

// Create styled date picker wrapper with same styles as reports page
const StyledDatePickerWrapper = withStyles((theme) => ({
  root: {
    "& .DayPicker__withBorder": {
      border: "none !important",
      boxShadow: "none",
      borderRadius: 4,
    },
    "& .DayPickerNavigation_leftButton__horizontalDefault": {
      left: "22px !important",
      right: "auto !important",
    },
    "& .DayPickerNavigation_rightButton__horizontalDefault": {
      right: "22px !important",
      left: "auto !important",
    },
    "& .DayPickerNavigation__horizontalDefault": {
      width: "auto !important",
      left: "0 !important",
      right: "0 !important",
    },
    "& .DayPickerNavigation": {
      position: "relative !important",
      width: "auto !important",
    },
    "& .DayPicker_weekHeader ul": {
      marginBottom: "8px !important",
    },
    "& .DayPickerNavigation_button": {
      position: "absolute !important",
      width: "32px !important",
      height: "32px !important",
      padding: "0 !important",
      display: "inline-flex !important",
      alignItems: "center !important",
      justifyContent: "center !important",
      boxSizing: "border-box !important",
      top: "10px !important",
    },
    "& .DayPicker_weekHeader": {
      paddingBottom: "8px !important",
    },
    "& .DayPicker_weekHeader_ul": {
      marginBottom: "8px !important",
    },
    "& .CalendarMonthGrid__horizontal": {
      marginTop: "6px !important",
    },
    "& .DayPickerNavigation .DayPickerNavigation_button:first-of-type": {
      left: "12px !important",
      right: "auto !important",
    },
    "& .DayPickerNavigation .DayPickerNavigation_button:last-of-type": {
      right: "12px !important",
      left: "auto !important",
    },
    "& .DayPicker": {
      display: "inline-block !important",
    },
    "& .CalendarMonth_caption": {
      color: theme.palette.text.primary,
      fontWeight: 600,
    },
    "& .CalendarDay__default": {
      background: theme.palette.white,
      color: theme.palette.text.primary,
      border: `1px solid ${theme.palette.divider}`,
    },
    "& .CalendarDay__hovered_span, & .CalendarDay__hovered_span:active, & .CalendarDay__hovered_span:hover": {
      background: theme.palette.highlight,
      color: theme.palette.brand,
      border: `1px double ${theme.palette.highlight}`,
    },
    "& .CalendarDay__selected_span, & .CalendarDay__selected_span:active, & .CalendarDay__selected_span:hover": {
      background: theme.palette.highlight,
      color: theme.palette.brand,
      border: `1px double ${theme.palette.highlight}`,
    },
    "& .CalendarDay__selected, & .CalendarDay__selected:active, & .CalendarDay__selected:hover": {
      background: theme.palette.brand,
      color: theme.palette.white,
      border: `1px double ${theme.palette.brand}`,
    },
    "& .CalendarDay__blocked_out_of_range, & .CalendarDay__blocked_out_of_range:active, & .CalendarDay__blocked_out_of_range:hover": {
      color: theme.palette.text.disabled,
      background: "transparent",
      border: `1px solid ${theme.palette.divider}`,
    },
    "& .DayPickerNavigation_button__default": {
      background: theme.palette.brand,
      border: "none",
      color: theme.palette.white,
    },
    "& .DayPickerNavigation_button__default:disabled": {
      background: theme.palette.action ? theme.palette.action.disabled : "#ccc",
      color: theme.palette.text.disabled,
    },
  },
  dateRangeContainer: {
    border: `1px solid ${theme.palette.divider}`,
    borderRadius: 4,
    display: "inline-block",
    padding: theme.spacing(1),
    backgroundColor: theme.palette.background ? theme.palette.background.paper : theme.palette.white,
    boxShadow: "0 1px 2px rgba(0,0,0,0.06)",
  },
}))(({ classes, children }) => (
  <div className={classes.root}>
    <div className={classes.dateRangeContainer}>
      {children}
    </div>
  </div>
));

const StyledFilterSection = withStyles((theme) => ({
  filterContainer: {
    margin: theme.spacing(1, 0),
    padding: theme.spacing(0.75, 1.5),
    border: `1px solid ${theme.palette.divider}`,
    borderRadius: 4,
    backgroundColor: theme.palette.background ? theme.palette.background.paper : theme.palette.white,
    boxShadow: "0 1px 2px rgba(0,0,0,0.06)",
  },
}))(({ classes, children }) => (
  <div className={classes.filterContainer}>
    {children}
  </div>
));

// const SettingsContext = createContext({});

class TimesheetReport extends React.Component {
  constructor(props) {
    super(props);

    this.byStaff = this.byStaff.bind(this);
    this.gotData = this.gotData.bind(this);
    this.setBySite = this.setBySite.bind(this);
    this.parseRows = this.parseRows.bind(this);
    this.flipState = this.flipState.bind(this);
    this.openPDF = this.openPDF.bind(this);
    this.settingsFlip = this.settingsFlip.bind(this);
    this.setSettings = this.setSettings.bind(this);
    this.clearFilter = this.clearFilter.bind(this);
    this.ConvertToCSV = this.ConvertToCSV.bind(this);
    this.handleFilterChange = this.handleFilterChange.bind(this);
    this.fetchData = this.fetchData.bind(this);
    this.hasQueryParams = this.hasQueryParams.bind(this);
    this.applyQuickRange = this.applyQuickRange.bind(this);
    this.toggleExpandAll = this.toggleExpandAll.bind(this);

    // Parse query parameters for initial filters
    const queryParams = queryString.parse(this.props.location.search);
    const defaultFrom = moment().subtract(7, "days").startOf("day");
    const defaultTo = moment().startOf("day");

    this.state = {
      uploaded: false,
      settingsVisible: false,
      settings: {
        timeFormat: "dec",
        staffOrder: "lastname",
        showLeave: true,
        showGeolocation: true,
        showStaffType: true,
        showTaskType: true,
        showEquipment: true,
        groupByDay: false,
        roundingEnabled: false,
        showNotes: true,
        showGrossHours: true,
        showLunch: true,
        showNetHours: true,
        approvedOnly: false,
      },
      view: "staff",
      filters: {
        from: queryParams.from ? moment(queryParams.from) : defaultFrom,
        to: queryParams.to ? moment(queryParams.to) : defaultTo,
        siteId: queryParams.siteId || "all",
        staffId: queryParams.staffId || null,
      },
      isLoading: false,
      focusedInput: "startDate",
      filtersExpanded: false,
      expandAll: false,
    };

    this.viewFlip = { staff: "site", site: "staff" };
  }

  componentDidMount() {
    const localSettingsRaw = localStorage.getItem(
      "safetywise_timesheetSettings"
    );
    if (localSettingsRaw) {
      try {
        const localSettings = JSON.parse(localSettingsRaw);
        if (localSettings.showGeolocation === undefined) {
          localSettings.showGeolocation = true;
        }
        if (localSettings.showStaffType === undefined) {
          localSettings.showStaffType = true;
        }
        if (localSettings.showTaskType === undefined) {
          localSettings.showTaskType = true;
        }
        if (localSettings.showEquipment === undefined) {
          localSettings.showEquipment = true;
        }
        if (localSettings.groupByDay === undefined) {
          localSettings.groupByDay = false;
        }
        if (localSettings.roundingEnabled === undefined) {
          localSettings.roundingEnabled = false;
        }
        if (localSettings.showNotes === undefined) {
          localSettings.showNotes = true;
        }
        if (localSettings.showGrossHours === undefined) {
          localSettings.showGrossHours = true;
        }
        if (localSettings.showLunch === undefined) {
          localSettings.showLunch = true;
        }
        if (localSettings.showNetHours === undefined) {
          localSettings.showNetHours = true;
        }
        if (localSettings.approvedOnly === undefined) {
          localSettings.approvedOnly = false;
        }

        this.setState({ settings: localSettings });
      } catch {
        console.log("Error loading settings");
      }
    } else {
      // If no localStorage settings, ensure showEquipment is set in initial state
      this.setState(prevState => ({
        settings: {
          ...prevState.settings,
          showEquipment: prevState.settings.showEquipment !== undefined ? prevState.settings.showEquipment : true
        }
      }));
    }

    // Check if data is passed through props (backward compatibility)
    const data = this.props.location.state || [];
    const queryParams = queryString.parse(this.props.location.search);

    // If query parameters exist, update filters and fetch data from API
    if (queryParams.from && queryParams.to) {
      const filters = {
        from: moment(queryParams.from),
        to: moment(queryParams.to),
        siteId: queryParams.siteId || "all",
        staffId: queryParams.staffId || null,
      };
      this.setState({ filters, isLoading: true }, () => {
        this.fetchData();
      });
    } else if (data.length > 0) {
      // Legacy: data passed via location.state
      const lines = data.split(/\r?\n/).filter(line => line.trim() !== '');
      const parsedData = lines.map(line => {
        return line.split(/,(?=(?:(?:[^"]*"){2})*[^"]*$)/).map(value => value.replace(/(^"|"$)/g, '').trim());
      });
  
      if (parsedData.length > 0) {
        this.gotData(parsedData);
      } else {
        alert("No timesheet data provided.");
      }

      const { history } = this.props;
      // Clear the state after loading the data
      history.replace({
        pathname: this.props.location.pathname,
        state: null
      });
    }
  }

  componentDidUpdate(prevProps) {
    // If query parameters changed, fetch new data
    if (prevProps.location.search !== this.props.location.search) {
      const queryParams = queryString.parse(this.props.location.search);
      if (queryParams.from && queryParams.to) {
        this.setState({
          filters: {
            from: moment(queryParams.from),
            to: moment(queryParams.to),
            siteId: queryParams.siteId || "all",
            staffId: queryParams.staffId || null,
          }
        }, () => {
          this.fetchData();
        });
      }
    }

    // If Redux data changed, process it
    if (prevProps.timesheetData !== this.props.timesheetData) {
      if (this.props.timesheetData) {
        const lines = this.props.timesheetData.split(/\r?\n/).filter(line => line.trim() !== '');
        const parsedData = lines.map(line => {
          return line.split(/,(?=(?:(?:[^"]*"){2})*[^"]*$)/).map(value => value.replace(/(^"|"$)/g, '').trim());
        });
        if (parsedData.length > 0) {
          this.gotData(parsedData);
        } else {
          this.setState({ isLoading: false });
        }
      }
    }
    
    // Stop loading when fetch completes (success or failure)
    if (prevProps.report?.saving === true && this.props.report?.saving === false && this.state.isLoading) {
      // Only stop loading if we don't have data (meaning fetch failed or returned empty)
      if (!this.props.timesheetData) {
        this.setState({ isLoading: false });
      }
    }
  }

  fetchData() {
    const { filters } = this.state;
    const { onFetchData } = this.props;
    
    if (!filters || !filters.from || !filters.to) {
      this.setState({ isLoading: false });
      return;
    }

    this.setState({ isLoading: true });
    
    onFetchData({
      from: filters.from.format(),
      to: filters.to.format(),
      siteId: filters.siteId,
      staffId: filters.staffId,
      approvedOnly:
        this.props.featureFlags?.timesheetApprovals === true &&
        this.state.settings?.approvedOnly === true,
    });
  }

  hasQueryParams() {
    const queryParams = queryString.parse(this.props.location.search);
    return !!(queryParams.from && queryParams.to);
  }

  applyQuickRange(key) {
    let startDate;
    let endDate;

    switch (key) {
      // ISO weeks are Monday (start) to Sunday (end)
      case "this_week": {
        startDate = moment().startOf("isoWeek");
        endDate = moment().endOf("isoWeek");
        break;
      }
      case "today": {
        const todayStart = moment().startOf("day");
        const todayEnd = todayStart.clone();
        startDate = todayStart;
        endDate = todayEnd;
        break;
      }
      case "last_week": {
        const lastWeekStart = moment().subtract(1, "week").startOf("isoWeek");
        const lastWeekEnd = moment().subtract(1, "week").endOf("isoWeek");
        startDate = lastWeekStart;
        endDate = lastWeekEnd;
        break;
      }
      case "past_two_weeks": {
        // Two full weeks immediately before the current week
        startDate = moment().subtract(2, "weeks").startOf("isoWeek");
        endDate = moment().subtract(1, "weeks").endOf("isoWeek");
        break;
      }
      case "this_month": {
        startDate = moment().startOf("month");
        endDate = moment().endOf("month");
        break;
      }
      case "last_month": {
        const lastMonthStart = moment().subtract(1, "month").startOf("month");
        const lastMonthEnd = moment().subtract(1, "month").endOf("month");
        startDate = lastMonthStart;
        endDate = lastMonthEnd;
        break;
      }
      default:
        return;
    }

    const newFilters = {
      ...this.state.filters,
      from: startDate,
      to: endDate,
    };

    this.setState({ 
      filters: newFilters,
      focusedInput: "startDate"
    });

    // Update URL and fetch data
    const { history } = this.props;
    const queryParams = new URLSearchParams();
    queryParams.set('from', startDate.format());
    queryParams.set('to', endDate.format());
    if (newFilters.siteId && newFilters.siteId !== 'all') {
      queryParams.set('siteId', newFilters.siteId);
    }
    if (newFilters.staffId) {
      queryParams.set('staffId', newFilters.staffId);
    }

    history.replace({
      pathname: this.props.location.pathname,
      search: queryParams.toString()
    });

    // Fetch new data
    this.fetchData();
  }

  handleFilterChange(filterName, value) {
    const { history } = this.props;
    const newFilters = {
      ...this.state.filters,
      [filterName]: value
    };

    this.setState({ filters: newFilters });

    // Update URL query parameters
    const queryParams = new URLSearchParams();
    queryParams.set('from', newFilters.from.format());
    queryParams.set('to', newFilters.to.format());
    if (newFilters.siteId && newFilters.siteId !== 'all') {
      queryParams.set('siteId', newFilters.siteId);
    }
    if (newFilters.staffId) {
      queryParams.set('staffId', newFilters.staffId);
    }

    history.replace({
      pathname: this.props.location.pathname,
      search: queryParams.toString()
    });

    // Fetch new data
    this.fetchData();
  }

  flipState(ns) {
    this.setState({ view: ns });
  }

  gotData(inc) {
    const dataType = inc[0][0];
    if (dataType !== "Timesheet Records") {
      alert("Invalid timesheet records file");
      console.error("Invalid timesheet records");
      this.setState({ isLoading: false });
      return;
    }
    const rows = this.parseRows(inc);
    //This sorts initial records by Date
    rows.sort(dateCompare);
    const byStaff = this.byStaff(rows);
    const bySite = this.setBySite(rows);
    const byEquipment = this.setByEquipment(rows);
    const range = dateRange(inc);


    let sortedKeys = Object.keys(byStaff).sort();
    if (this.state.settings.staffOrder == 'lastname') {
      sortedKeys = Object.keys(byStaff).sort((a, b) => {
        const lastA = a.split(' ')[1] || a || '';
        const lastB = b.split(' ')[1] || b || '';
        return lastA.localeCompare(lastB);
      });
    }

    const sortedStaff = {};
    for (const key of sortedKeys) {
      sortedStaff[key] = byStaff[key];
    }


    let sortedSiteKeys = Object.keys(bySite).sort();

    const sortedSite = [];
    for (const key of sortedSiteKeys) {
      sortedSite[key] = bySite[key];
    }

    for (let st of Object.keys(sortedSite)) {
      let sortedStaffKeys = Object.keys(sortedSite[st].staff).sort();

      if (this.state.settings.staffOrder == 'lastname') {
        sortedStaffKeys = Object.keys(byStaff).sort((a, b) => {
          const lastA = a.split(' ')[1] || a || '';
          const lastB = b.split(' ')[1] || b || '';
          return lastA.localeCompare(lastB);
        });
      }

      const sortedSiteStaff = {};
      for (const key of sortedStaffKeys) {
        if (sortedSite[st].staff[key]) {
          sortedSiteStaff[key] = sortedSite[st].staff[key];
        }
      }

      sortedSite[st].staff = sortedSiteStaff;
    }


    // Sort equipment data
    let sortedEquipmentKeys = Object.keys(byEquipment).sort();
    const sortedEquipment = {};
    for (const key of sortedEquipmentKeys) {
      sortedEquipment[key] = byEquipment[key];
    }

    for (let eq of Object.keys(sortedEquipment)) {
      let sortedStaffKeys = Object.keys(sortedEquipment[eq].staff).sort();
      if (this.state.settings.staffOrder == 'lastname') {
        sortedStaffKeys = sortedStaffKeys.sort((a, b) => {
          const lastA = a.split(' ')[1] || a || '';
          const lastB = b.split(' ')[1] || b || '';
          return lastA.localeCompare(lastB);
        });
      }
      const sortedEquipmentStaff = {};
      for (const key of sortedStaffKeys) {
        if (sortedEquipment[eq].staff[key]) {
          sortedEquipmentStaff[key] = sortedEquipment[eq].staff[key];
        }
      }
      sortedEquipment[eq].staff = sortedEquipmentStaff;
    }

    this.setState({ hours: sortedStaff }, () => {
      this.setState({ bySite: sortedSite }, () => {
        this.setState({ byEquipment: sortedEquipment }, () => {
          this.setState({ range: range }, () => {
            this.setState({ uploaded: true, isLoading: false }, () => { });
          });
        });
      });
    });
  }

  async openPDF(sites, staff, equipment, settings, view) {
    const siteLabel = this.props.featureFlags?.siteLabel?.trim() || "Site";
    if (view === "staff") {
      await createPDF("staff", staff, this.state.range, settings, siteLabel);
    } else if (view === "equipment") {
      await createPDF("equipment", equipment, this.state.range, settings, siteLabel);
    } else {
      await createPDF("site", sites, this.state.range, settings, siteLabel);
    }
  }

  setBySite(rows) {
    const sites = [];

    rows.forEach((x) => {
      if (ki(sites, x.site)) {
        //site object exists
        sites[x.site].total += x.hours;
        sites[x.site].lunch += x.lunchAmount;
        sites[x.site].roundedTotal += x.roundedNetHours;
        x.ers.forEach((er) => {
          if (!sites[x.site].ers.includes(er)) {
            sites[x.site].ers.push(er);
          }
        });

        if (ki(sites[x.site].staff, x.staff)) {
          //staff object in site exists
          sites[x.site].staff[x.staff].records.push(x);
          sites[x.site].staff[x.staff].total += x.hours;
          sites[x.site].staff[x.staff].lunch += x.lunchAmount;
          sites[x.site].staff[x.staff].roundedTotal += x.roundedNetHours;

          x.ers.forEach((er) => {
            if (!sites[x.site].staff[x.staff].ers.includes(er)) {
              sites[x.site].staff[x.staff].ers.push(er);
            }
          });
        } else {
          //no staff object in site, create
          sites[x.site].staff[x.staff] = {
            total: x.hours,
            lunch: x.lunchAmount,
            roundedTotal: x.roundedNetHours,
            records: [x],
            ers: [...x.ers],
          };
        }
      } else {
        //no site object, create
        sites[x.site] = {
          total: x.hours,
          lunch: x.lunchAmount,
          roundedTotal: x.roundedNetHours,
          staff: {},
          ers: [...x.ers],
        };
        sites[x.site].staff[x.staff] = {
          total: x.hours,
          lunch: x.lunchAmount,
          roundedTotal: x.roundedNetHours,
          records: [x],
          ers: [...x.ers],
        };
      }
    });

    Object.keys(sites).forEach((x) => {
      Object.keys(sites[x].staff).forEach((y) => {
        sites[x].staff[y].records = sites[x].staff[y].records.sort(
          (x, y) => +new Date(x.start) - +new Date(y.start)
        );
      });
    });

    return sites;
  }

  setByEquipment(rows) {
    const equipment = [];

    rows.forEach((x) => {
      // Exclude records with no equipment when organising by equipment
      // (equipment view should not include a "-" / empty equipment bucket)
      const equipmentName = (x.equipment ?? "").toString().trim();
      if (!equipmentName || equipmentName === "-") {
        return;
      }
      
      if (ki(equipment, equipmentName)) {
        //equipment object exists
        equipment[equipmentName].total += x.hours;
        equipment[equipmentName].lunch += x.lunchAmount;
        equipment[equipmentName].roundedTotal += x.roundedNetHours;
        x.ers.forEach((er) => {
          if (!equipment[equipmentName].ers.includes(er)) {
            equipment[equipmentName].ers.push(er);
          }
        });

        if (ki(equipment[equipmentName].staff, x.staff)) {
          //staff object in equipment exists
          equipment[equipmentName].staff[x.staff].records.push(x);
          equipment[equipmentName].staff[x.staff].total += x.hours;
          equipment[equipmentName].staff[x.staff].lunch += x.lunchAmount;
          equipment[equipmentName].staff[x.staff].roundedTotal += x.roundedNetHours;

          x.ers.forEach((er) => {
            if (!equipment[equipmentName].staff[x.staff].ers.includes(er)) {
              equipment[equipmentName].staff[x.staff].ers.push(er);
            }
          });
        } else {
          //no staff object in equipment, create
          equipment[equipmentName].staff[x.staff] = {
            total: x.hours,
            lunch: x.lunchAmount,
            roundedTotal: x.roundedNetHours,
            records: [x],
            ers: [...x.ers],
          };
        }
      } else {
        //no equipment object, create
        equipment[equipmentName] = {
          total: x.hours,
          lunch: x.lunchAmount,
          roundedTotal: x.roundedNetHours,
          staff: {},
          ers: [...x.ers],
        };
        equipment[equipmentName].staff[x.staff] = {
          total: x.hours,
          lunch: x.lunchAmount,
          roundedTotal: x.roundedNetHours,
          records: [x],
          ers: [...x.ers],
        };
      }
    });

    Object.keys(equipment).forEach((x) => {
      Object.keys(equipment[x].staff).forEach((y) => {
        equipment[x].staff[y].records = equipment[x].staff[y].records.sort(
          (x, y) => +new Date(x.start) - +new Date(y.start)
        );
      });
    });

    return equipment;
  }

  ConvertToCSV(objArray) {
    var array = typeof objArray != 'object' ? JSON.parse(objArray) : objArray;
    var result = [];

    for (var i = 0; i < array.length; i++) {
      var line = [];
      for (var index in array[i]) {
        // if (line != '') line += ','

        line.push(array[i][index]);
      }

      result.push(line);
    }

    return result;
  }

  parseRows(inc, skipHeaders = false) {
    // Ensure we always work on a copy
    let data = Array.isArray(inc) ? [...inc] : [];

    // Nothing to parse
    if (!data.length) {
      return [];
    }

    // Save header row before slicing
    let headerRow = null;
    if (!skipHeaders && data.length > 1) {
      // First row: title ("Timesheet Records"), second row: header columns
      headerRow = data[1];
      // Drop the title + header rows without emptying the array incorrectly
      data = data.slice(2);
    }

    // No data rows after removing headers
    if (!data.length) {
      return [];
    }

    const firstRow = data[0] || [];
    const hasLunch = firstRow.length > 9;
    const newGeo = firstRow.length > 11;
    
    // Check header row for Equipment column if available
    let equipmentIndex = null;
    if (headerRow && Array.isArray(headerRow)) {
      equipmentIndex = headerRow.findIndex((col) =>
        col && col.toString().toLowerCase().includes("equipment")
      );
    }
    
    let keys;

    if (newGeo) {
      keys = {
        startDate: 1,
        startTime: 2,
        endDate: 4,
        endTime: 5,
        lunch: 3,
        geoStart: 10,
        geoEnd: 11,
        staffType: 12,
        taskType: 13,
        equipment: 14,
        site: 7,
        notes: 6,
      };
    } else {
      if (hasLunch) {
        keys = {
          startDate: 1,
          startTime: 2,
          endDate: 4,
          endTime: 5,
          lunch: 3,
        geoEnd: 10,
        staffType: 11,
        taskType: 12,
        equipment: 13,
        site: 7,
        notes: 6,
        };
      } else {
        keys = {
          startDate: 1,
          startTime: 2,
          endDate: 3,
          endTime: 4,
        geoEnd: 9,
        staffType: 10,
        taskType: 11,
        equipment: 12,
        site: 6,
        notes: 5,
        };
      }
    }

    const dataOut = [];

    data.forEach((x, i) => {
      if (x.length < 10) {
        return;
      }
      const dateFormat = "D MMM YYYY h:mm a";
      const ers = [];

      let start = x[1] + " " + x[2];
      let end = x[keys["endDate"]] + " " + x[keys["endTime"]];

      let mStart = moment(start, dateFormat);
      let mEnd = moment(end, dateFormat);

      let staff = x[0];

      if (!mStart.isValid() || !mEnd.isValid()) {
        console.log("Invalid date");
        console.log(x);
        mStart = moment(start, "D-MMM-YYYY h:mm a");
        mEnd = moment(end, "D-MMM-YYYY h:mm a");
      }

        const mStartR = roundToQuarterHour(mStart);
        const mEndR   = roundToQuarterHour(mEnd);

      let formattedStart = mStart.format("ddd D MMM YYYY h:mm a");
      let formattedEnd = mEnd.format("ddd D MMM YYYY h:mm a");

      let hours = mEnd.diff(mStart, "hours", true);

      let lunch = x[keys["lunch"]];
      let lunchH;

      if (hasLunch) {
        let lunchAmt = parseInt(x[keys["lunch"]].split(" ")[0]);
        if (lunchAmt === 60) {
          lunchH = 1;
        } else if (lunchAmt === 45) {
          lunchH = 0.75;
        } else if (lunchAmt === 30) {
          lunchH = 0.5;
        } else {
          lunchH = 0;
          lunch = "-";
        }
      }

      if (hours < 0) {
        ers.push(ers_all[0]);
      }

      if (staff.length < 1) {
        ers.push(ers_all[1]);
        staff = "-";
      }

      let geoStart;
      let geoEnd;

      if (newGeo) {
        geoStart = parseGeo(x[keys.geoStart]);
        geoEnd = parseGeo(x[keys.geoEnd]);
      } else {
        geoStart = "";
        geoEnd = parseGeo(x[keys.geoEnd]);
      }

      // Get equipment value - use header-based index if available, otherwise use keys
      let equipmentValue = "";
      if (equipmentIndex !== null && equipmentIndex >= 0 && x[equipmentIndex] !== undefined) {
        equipmentValue = x[equipmentIndex];
      } else if (keys.equipment !== undefined && x[keys.equipment] !== undefined) {
        equipmentValue = x[keys.equipment];
      }

      const roundedGrossHours = mEndR.diff(mStartR, "hours", true);
      const roundedNetHours = Math.max(0, roundedGrossHours - (lunchH || 0));

      let newRow = {
        staff: staff,
        hours: hours,
        start: formattedStart,
        end: formattedEnd,
        startMs: mStart.isValid() ? mStart.valueOf() : null,
        endMs: mEnd.isValid() ? mEnd.valueOf() : null,
        site: x[keys.site],
        ers: ers,
        lunch: lunch || "-",
        lunchAmount: lunchH || 0,
        netHours: hours - lunchH,
        roundedNetHours: roundedNetHours,
        geoStart: geoStart,
        geoEnd: geoEnd,
        notes: x[keys.notes],
        staffType: x[keys.staffType],
        taskType: x[keys.taskType],
        equipment: equipmentValue || "",
      };

      dataOut.push(newRow);
    });

    markOverlappingTimesheetRows(dataOut);
    dataOut.forEach((row) => {
      delete row.startMs;
      delete row.endMs;
    });

    return dataOut;
  }

  byStaff(rows) {
    let staff = {};
    rows.forEach((x) => {
      if (ki(staff, x.staff)) {
        staff[x.staff].total += x.hours;
        staff[x.staff].lunch += x.lunchAmount;
        staff[x.staff].roundedTotal += x.roundedNetHours;
        staff[x.staff].records.push(x);
        if (x.ers) {
          x.ers.forEach((er) => {
            if (!staff[x.staff].ers.includes(er)) {
              staff[x.staff].ers.push(er);
            }
          });
        }
      } else {
        staff[x.staff] = {
          total: x.hours,
          lunch: x.lunchAmount,
          roundedTotal: x.roundedNetHours,
          records: [x],
          ers: [...x.ers],
        };
      }
    });

    Object.keys(staff).forEach((x) => {
      staff[x].records = staff[x].records.sort(
        (x, y) => +new Date(x.start) - +new Date(y.start)
      );
    });
    return staff;
  }

  settingsFlip() {
    this.setState({ settingsVisible: !this.state.settingsVisible }, () => {
    });
  }

  toggleExpandAll() {
    this.setState((prev) => ({ expandAll: !prev.expandAll }));
  }

  clearFilter(props, filterValue, setFilterValue, setStaff, setSite) {
    setStaff("");
    setSite("");
    setFilterValue("");
  }

  setSettings(newSettings) {
    const roundingChanged =
      newSettings.roundingEnabled !== this.state.settings.roundingEnabled;
    const approvedOnlyChanged =
      newSettings.approvedOnly !== this.state.settings.approvedOnly;

    this.setState({ settings: newSettings }, () => {
      localStorage.setItem(
        "safetywise_timesheetSettings",
        JSON.stringify(newSettings)
      );

      if (approvedOnlyChanged && this.hasQueryParams()) {
        this.fetchData();
        return;
      }

      if (roundingChanged && this.props.timesheetData) {
        const lines = this.props.timesheetData.split(/\r?\n/).filter(line => line.trim() !== '');
        const parsedData = lines.map(line =>
          line.split(/,(?=(?:(?:[^"]*"){2})*[^"]*$)/).map(value => value.replace(/(^"|"$)/g, '').trim())
        );
        if (parsedData.length > 0) {
          this.gotData(parsedData);
        }
      }
    });
  }

  render() {
    const siteLabel = this.props.featureFlags?.siteLabel?.trim() || "Site";
    const queryParams = queryString.parse(this.props.location.search);
    const reportTitle = queryParams.type === "leave" ? "Leave Report" : "Timesheet Report";
    return (
      <div className={page}>
        <Provider value={this.state.settings}>

          <div className={content}>
            <table className={titleRowTable} style={{ width: "100%" }}>
              <tbody>
                <tr>
                  <td style={{ width: "250px" }} className={title}>
                    {reportTitle}
                  </td>
                  <td style={{ textAlign: "right", verticalAlign: "middle" }}>
                    {this.state.uploaded && (
                      <div style={{ display: "inline-flex", alignItems: "center", gap: 4 }}>
                        <Tooltip title={this.state.settingsVisible ? "Hide format settings" : "Format settings"}>
                          <IconButton
                            size="small"
                            onClick={this.settingsFlip}
                            aria-label={this.state.settingsVisible ? "Hide format settings" : "Show format settings"}
                            aria-expanded={this.state.settingsVisible}
                            data-cy="timesheet-format-settings-toggle"
                            style={this.state.settingsVisible ? {
                              backgroundColor: "#c1c72c",
                              color: "#1C315E",
                            } : {}}
                          >
                            <FilterListIcon />
                          </IconButton>
                        </Tooltip>
                        <Tooltip title={this.state.expandAll ? "Collapse all" : "Expand all"}>
                          <IconButton
                            size="small"
                            onClick={this.toggleExpandAll}
                            style={this.state.expandAll ? {
                              backgroundColor: "#e8ea9a",
                              color: "#3c7a3c",
                            } : {}}
                          >
                            <UnfoldMoreIcon style={{ transform: this.state.expandAll ? "rotate(180deg)" : "rotate(0deg)", transition: "transform 0.2s" }} />
                          </IconButton>
                        </Tooltip>
                      </div>
                    )}
                  </td>
                </tr>
              </tbody>
            </table>

            {this.state.uploaded && (
              <Collapse in={this.state.settingsVisible}>
                <Settings
                  variant="accordion"
                  settings={this.state.settings}
                  settingsCallback={this.setSettings}
                  featureFlags={this.props.featureFlags}
                />
              </Collapse>
            )}

            {/* Filter Controls - Collapsible */}
            {this.state.filters && (
              <StyledFilterSection>
                {/* Collapsed Header - Date Range Summary */}
                <div 
                  style={{ 
                    display: "flex", 
                    justifyContent: "space-between", 
                    alignItems: "center",
                    cursor: "pointer",
                    minHeight: 32,
                    marginBottom: this.state.filtersExpanded ? "8px" : "0"
                  }}
                  onClick={() => this.setState({ filtersExpanded: !this.state.filtersExpanded })}
                >
                  <Typography variant="subtitle1" style={{ margin: 0, fontWeight: 500, lineHeight: 1.3 }}>
                    {this.state.filters.from && this.state.filters.to ? (
                      <>
                        {this.state.filters.from.format("D MMM YYYY")} to {this.state.filters.to.format("D MMM YYYY")}
                        {this.state.filters.from && this.state.filters.to
                          ? ` (${this.state.filters.to.startOf("day").diff(this.state.filters.from.startOf("day"), "days") + 1} days)`
                          : ""}
                      </>
                    ) : (
                      "Filters"
                    )}
                  </Typography>
                  <IconButton 
                    size="small"
                    aria-label={this.state.filtersExpanded ? "Collapse" : "Expand"}
                    style={{ padding: 4 }}
                  >
                    {this.state.filtersExpanded ? <ExpandLessIcon fontSize="small" /> : <ExpandMoreIcon fontSize="small" />}
                  </IconButton>
                </div>
                
                {/* Expanded Content */}
                <Collapse in={this.state.filtersExpanded}>
                  <Grid container spacing={2}>
                  {/* Site selection - above date range */}
                  <Grid item xs={12}>
                    <SelectInput
                      id="site-filter"
                      label={siteLabel}
                      options={[
                        { label: `All ${siteLabel}s`, value: "all" },
                        ...(this.props.siteList || []).map(s => ({ label: s.siteName, value: s.id }))
                      ]}
                      value={this.state.filters.siteId || "all"}
                      onChange={(value) => this.handleFilterChange('siteId', value)}
                    />
                  </Grid>
                  
                  {/* Date Range */}
                  <Grid item xs={12}>
                    <Typography variant="caption" style={{ display: "block", marginBottom: "5px", color: "#666", fontWeight: 500 }}>
                      Date Range
                    </Typography>
                    <div>
                      {/* Quick Range Buttons */}
                      <div style={{ marginBottom: "10px", display: "flex", flexWrap: "wrap", gap: "8px" }}>
                        <Button size="small" variant="outlined" onClick={() => this.applyQuickRange("today")}>
                          Today
                        </Button>
                        <Button size="small" variant="outlined" onClick={() => this.applyQuickRange("this_week")}>
                          This week
                        </Button>
                        <Button size="small" variant="outlined" onClick={() => this.applyQuickRange("last_week")}>
                          Last week
                        </Button>
                        <Button size="small" variant="outlined" onClick={() => this.applyQuickRange("past_two_weeks")}>
                          Past two weeks
                        </Button>
                        <Button size="small" variant="outlined" onClick={() => this.applyQuickRange("this_month")}>
                          This month
                        </Button>
                        <Button size="small" variant="outlined" onClick={() => this.applyQuickRange("last_month")}>
                          Last Month
                        </Button>
                      </div>
                      
                      {/* Date Range Picker */}
                      <StyledDatePickerWrapper>
                        <DayPickerRangeController
                          startDate={this.state.filters.from}
                          endDate={this.state.filters.to}
                          firstDayOfWeek={1}
                          onDatesChange={({ startDate, endDate }) => {
                            // If a full range exists and user clicks a new date, start a new range
                            if (this.state.focusedInput === "startDate" && startDate) {
                              endDate = null;
                            }
                            // Update state immediately to allow free date selection
                            const newFilters = {
                              ...this.state.filters,
                              // Keep the selected start date but allow endDate to clear
                              // while the user picks a new range (same behavior as Reports screen).
                              from: startDate || this.state.filters.from,
                              to: endDate,
                            };
                            this.setState({ 
                              filters: newFilters,
                              focusedInput: startDate && !endDate ? "endDate" : "startDate"
                            });
                            // Only update URL and fetch when both dates are selected
                            if (startDate && endDate) {
                              this.handleFilterChange('from', startDate);
                              this.handleFilterChange('to', endDate);
                            } else if (startDate) {
                              // Update start date in URL even if end date not selected
                              const { history } = this.props;
                              const queryParams = new URLSearchParams(this.props.location.search);
                              queryParams.set('from', startDate.format());
                              history.replace({
                                pathname: this.props.location.pathname,
                                search: queryParams.toString()
                              });
                            }
                          }}
                          focusedInput={this.state.focusedInput || "startDate"}
                          onFocusChange={(focusedInput) => this.setState({ focusedInput: focusedInput || "startDate" })}
                          numberOfMonths={2}
                          initialVisibleMonth={() => moment().subtract(1, "month")}
                          daySize={40}
                          navPrev={<ChevronLeftIcon />}
                          navNext={<ChevronRightIcon />}
                          isOutsideRange={(day) => day.isAfter(moment(), "day")}
                          minimumNights={0}
                          hideKeyboardShortcutsPanel
                        />
                      </StyledDatePickerWrapper>
                    </div>
                    {this.state.isLoading && (
                      <Typography variant="body2" style={{ marginTop: "10px", color: "#666" }}>Loading data...</Typography>
                    )}
                  </Grid>
                </Grid>
                </Collapse>
              </StyledFilterSection>
            )}

            {/* Show upload dropzone only if no query parameters and no data loaded */}
            {!this.state.uploaded && !this.hasQueryParams() ? (
              <div className={upload}>
                <MyDropzone
                  callBack={this.gotData}
                  className={dropzone}
                  accept=".csv"
                ></MyDropzone>
              </div>
            ) : this.state.isLoading ? (
              <div style={{ padding: "60px 20px", textAlign: "center", minHeight: "200px", display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center" }}>
                <CircularProgress size={50} style={{ marginBottom: "20px", color: "#3498db" }} />
                <Typography variant="h5" style={{ marginBottom: "15px", fontWeight: 600 }}>Loading Timesheet Data</Typography>
                <Typography variant="body1" style={{ color: "#666" }}>
                  Please wait while we fetch your timesheet report...
                </Typography>
              </div>
            ) : this.state.uploaded ? (
              <div>
                <ViewRows
                  key={`view-${this.state.view}-equipment-${this.state.settings?.showEquipment}`}
                  state={this.state}
                  pdf={this.openPDF}
                  cb={this.flipState}
                  view={this.state.view}
                  range={this.state.range}
                  hours={this.state.hours}
                  site={this.state.bySite}
                  equipment={this.state.byEquipment}
                  settings={this.state.settings}
                  featureFlags={this.props.featureFlags}
                  expandAll={this.state.expandAll}
                ></ViewRows>
              </div>
            ) : null}
          </div>
        </Provider>
      </div>
    );
  }
}

const SearchBox = (props) => {
  const { siteLabel } = useTerminology();
  const placeHolder =
    props.state === "staff"
      ? "Filter by staff member name"
      : props.state === "equipment"
      ? "Filter by equipment name"
      : `Filter by ${siteLabel} name`;

  const [lastState, setLastState] = useState(props.state);
  const [value, setValue] = useState("");

  useEffect(() => {
    if (props.state !== lastState) {
      setValue("");
      props.setFilterValue("");
      setLastState(props.state);
      props.setStaff("");
      props.setSite("");
      if (props.setEquipment) {
        props.setEquipment("");
      }
    }
  }, [props.state, lastState, props]);

  const handleChange = (evt) => {
    setValue(evt);
    props.setFilterValue(evt);
    if (props.state === "staff") {
      props.setStaff(evt);
    } else {
      props.setSite(evt);
    }
  };

  return (
    <input
      className={searchBox}
      placeholder={placeHolder}
      value={value}
      onChange={(x) => handleChange(x.target.value)}
    ></input>
  );
};



const ViewRows = (props) => {
  const settings = useContext(Context);
  const [staffSearch, setStaffSearch] = useState("");
  const [siteSearch, setSiteSearch] = useState("");
  const [equipmentSearch, setEquipmentSearch] = useState("");
  const [filterValue, setFilterValue] = useState("");

  const staff = applySearch(staffSearch, props.hours, props.settings, "staff");
  const sites = applySearch(siteSearch, props.site, props.settings, "site");
  const equipment = applySearch(equipmentSearch, props.equipment || {}, props.settings, "equipment");

  let sortedKeys = Object.keys(staff).sort();

  if (props.settings.staffOrder === "lastname") {
    sortedKeys = Object.keys(staff).sort((a, b) => {
      return a.split(" ")[1].localeCompare(b.split(" ")[1]);
    });
  }

  const sortedStaffData = {};
  for (const key of sortedKeys) {
    if (!props.settings.showLeave) {
      const newStaff = { ...staff };
      newStaff[key].records = newStaff[key].records.filter(
        (c) => c.site.indexOf("Leave -") < 0
      );
      newStaff[key].total = newStaff[key].records.reduce(
        (accumulator, currentRecord) => accumulator + currentRecord.hours,
        0
      );
      newStaff[key].lunch = newStaff[key].records.reduce(
        (accumulator, currentRecord) => accumulator + currentRecord.lunchAmount,
        0
      );
      newStaff[key].roundedTotal = newStaff[key].records.reduce(
        (accumulator, currentRecord) => accumulator + currentRecord.roundedNetHours,
        0
      );
      sortedStaffData[key] = newStaff[key];
    } else {
      sortedStaffData[key] = staff[key];
    }
  }

  let sortedSiteKeys = Object.keys(sites).sort();
  if (!props.settings.showLeave) {
    sortedSiteKeys = sortedSiteKeys.filter((c) => c.indexOf("Leave -") < 0);
  }

  const sortedSite = {};
  for (const key of sortedSiteKeys) {
    sortedSite[key] = sites[key];
  }

  for (let st of Object.keys(sortedSite)) {
    let sortedStaffKeys = Object.keys(sortedSite[st].staff).sort();
    if (props.settings.staffOrder === "lastname") {
      sortedStaffKeys = sortedStaffKeys.sort((a, b) => {
        return a.split(" ")[1].localeCompare(b.split(" ")[1]);
      });
    }

    const sortedSiteStaff = {};
    for (const key of sortedStaffKeys) {
      if (sortedSite[st].staff[key]) {
        sortedSiteStaff[key] = sortedSite[st].staff[key];
      }
    }

    sortedSite[st].staff = sortedSiteStaff;
  }

  // Sort equipment data
  let sortedEquipmentKeys = Object.keys(equipment).sort();
  const sortedEquipment = {};
  for (const key of sortedEquipmentKeys) {
    sortedEquipment[key] = equipment[key];
  }

  for (let eq of Object.keys(sortedEquipment)) {
    let sortedStaffKeys = Object.keys(sortedEquipment[eq].staff).sort();
    if (props.settings.staffOrder === "lastname") {
      sortedStaffKeys = sortedStaffKeys.sort((a, b) => {
        return a.split(" ")[1].localeCompare(b.split(" ")[1]);
      });
    }
    const sortedEquipmentStaff = {};
    for (const key of sortedStaffKeys) {
      if (sortedEquipment[eq].staff[key]) {
        sortedEquipmentStaff[key] = sortedEquipment[eq].staff[key];
      }
    }
    sortedEquipment[eq].staff = sortedEquipmentStaff;
  }

  return (
    <div>
      {/* Buttons row - Organise by Staff / Site / Equipment */}
      <div style={{ marginTop: "10px", display: "flex", alignItems: "center", justifyContent: "space-between", width: "100%" }}>
        <FlipButtons state={props.view} cb={props.cb} featureFlags={props.featureFlags}></FlipButtons>
      </div>
      {/* Search and Download row */}
      <table className={titleRowTable} style={{ marginTop: "-20px" }}>
        <tbody>
          <tr>
            <td>
              <div style={{ display: "contents" }}>
                <SearchBox
                  state={props.view}
                  setStaff={setStaffSearch}
                  setSite={setSiteSearch}
                  setEquipment={setEquipmentSearch}
                  filterValue={filterValue}
                  setFilterValue={setFilterValue}
                ></SearchBox>
              </div>
            </td>
            <td>
              <div className={downloadAsPdf}>
                Download as&nbsp;
                <a
                  onClick={() => props.pdf(sortedSite, sortedStaffData, sortedEquipment, props.settings, props.view)}
                  className={flipButtonAnchor}
                >
                  PDF
                </a>
                &nbsp;or&nbsp;
                <DataExport
                  sites={sortedSite}
                  staff={sortedStaffData}
                  equipment={sortedEquipment}
                  settings={props.settings}
                  view={props.view}
                  csvColumns={props.featureFlags?.timesheetCsvColumns}
                ></DataExport>
              </div>

            </td>
          </tr>
        </tbody>
      </table>

      {props.view === "staff" ? (
        <Hours
          data={sortedStaffData}
          range={props.range}
          showGeolocation={props.settings?.showGeolocation !== false}
          showStaffType={props.settings?.showStaffType !== false}
          showTaskType={props.settings?.showTaskType !== false}
          showEquipment={props.settings?.showEquipment !== false}
          showRounding={props.settings?.roundingEnabled === true}
          showNotes={props.settings?.showNotes !== false}
          showGrossHours={props.settings?.showGrossHours !== false}
          showLunch={props.settings?.showLunch !== false}
          showNetHours={props.settings?.showNetHours !== false}
          groupByDay={props.settings?.groupByDay === true}
          expandAll={props.expandAll}
        ></Hours>
      ) : props.view === "equipment" ? (
        <EquipmentView
          data={sortedEquipment}
          range={props.range}
          showGeolocation={props.settings?.showGeolocation !== false}
          showStaffType={props.settings?.showStaffType !== false}
          showTaskType={props.settings?.showTaskType !== false}
          showEquipment={props.settings?.showEquipment !== false}
          showRounding={props.settings?.roundingEnabled === true}
          showNotes={props.settings?.showNotes !== false}
          showGrossHours={props.settings?.showGrossHours !== false}
          showLunch={props.settings?.showLunch !== false}
          showNetHours={props.settings?.showNetHours !== false}
          groupByDay={props.settings?.groupByDay === true}
          expandAll={props.expandAll}
        ></EquipmentView>
      ) : (
        <SiteView
          data={sortedSite}
          range={props.range}
          showGeolocation={props.settings?.showGeolocation !== false}
          showStaffType={props.settings?.showStaffType !== false}
          showTaskType={props.settings?.showTaskType !== false}
          showEquipment={props.settings?.showEquipment !== false}
          showRounding={props.settings?.roundingEnabled === true}
          showNotes={props.settings?.showNotes !== false}
          showGrossHours={props.settings?.showGrossHours !== false}
          showLunch={props.settings?.showLunch !== false}
          showNetHours={props.settings?.showNetHours !== false}
          groupByDay={props.settings?.groupByDay === true}
          expandAll={props.expandAll}
        ></SiteView>
      )}
    </div>
  );
};

function applySearch(query, object, settings, type) {
  if (!query) {
    return object;
  }
  let out = {};
  // Use exact substring matching instead of fuzzy matching
  const keys = Object.keys(object).filter((x) => 
    x.toLowerCase().includes(query.toLowerCase())
  );
  keys.forEach((x) => (out[x] = object[x]));

  return out;
}

const FlipButtons = (props) => {
  const inactive = flipButton;
  const active = `${flipButton} ${flipActive}`;
  const equipmentEnabled = props.featureFlags?.equipment === true;
  const { siteLabel } = useTerminology();
  
  return (
    <div className={flipContainer} >
      <a
        onClick={() => props.cb("staff")}
        className={props.state === "staff" ? active : inactive}
      >
        Organise by Staff Member
      </a>
      <a
        onClick={() => props.cb("site")}
        className={props.state === "site" ? active : inactive}
      >
        Organise by {siteLabel}
      </a>
      {equipmentEnabled && (
        <a
          onClick={() => props.cb("equipment")}
          className={props.state === "equipment" ? active : inactive}
        >
          Organise by Equipment
        </a>
      )}
    </div>
  );
};

const SiteView = (props) => {
  const range = props.range;
  const sites = props.data;

  return (
    <div>
      {k(sites).map((site, i) => (
        <Site
          name={site}
          data={sites[site]}
          key={i}
          showGeolocation={props.showGeolocation}
          showStaffType={props.showStaffType}
          showTaskType={props.showTaskType}
          showEquipment={props.showEquipment}
          showRounding={props.showRounding}
          showNotes={props.showNotes}
          showGrossHours={props.showGrossHours}
          showLunch={props.showLunch}
          showNetHours={props.showNetHours}
          groupByDay={props.groupByDay}
          expandAll={props.expandAll}
        ></Site>
      ))}
    </div>
  );
};

const Site = (props) => {
  const { siteLabel } = useTerminology();
  return (
    <div className={`${row} ${row_site}`}>
      <div className={row_main}>
        <div className={row_col_site_name}>
          <div className={row_title}>{siteLabel} name</div>
          <div className={row_value}>{props.name || "-"}</div>
        </div>

        {props.showGrossHours !== false && (
          <div className={row_col_hours}>
            <div className={row_title}>Gross Hours</div>
            <div className={row_value}>
              <DisplayHours hours={Math.round(props.data.total * 100) / 100} />
            </div>
          </div>
        )}

        {props.showLunch !== false && (
          <div className={row_col_hours}>
            <div className={row_title}>Breaks</div>
            <div className={row_value}>
              <DisplayHours hours={Math.round(props.data.lunch * 100) / 100} />
            </div>
          </div>
        )}

        {props.showNetHours !== false && (
          <div className={row_col_hours}>
            <div className={row_title}>Net hours</div>
            <div className={row_value}>
              <DisplayHours
                hours={
                  Math.round((props.data.total - props.data.lunch) * 100) / 100
                }
              />
            </div>
          </div>
        )}

        {props.showRounding && (
          <div className={row_col_hours}>
            <div className={row_title}>Rounded</div>
            <div className={row_value}>
              <DisplayHours hours={props.data.roundedTotal || 0} />
            </div>
          </div>
        )}
      </div>

      <div className={rowsCont}>
        <Hours
          data={props.data.staff}
          siteMode={true}
          showGeolocation={props.showGeolocation}
          showStaffType={props.showStaffType}
          showTaskType={props.showTaskType}
          showEquipment={props.showEquipment}
          showRounding={props.showRounding}
          showNotes={props.showNotes}
          showGrossHours={props.showGrossHours}
          showLunch={props.showLunch}
          showNetHours={props.showNetHours}
          groupByDay={props.groupByDay}
          expandAll={props.expandAll}
        ></Hours>
      </div>
    </div>
  );
};

const EquipmentView = (props) => {
  const range = props.range;
  const equipment = props.data;

  return (
    <div>
      {k(equipment).map((eq, i) => (
        <Equipment
          name={eq}
          data={equipment[eq]}
          key={i}
          showGeolocation={props.showGeolocation}
          showStaffType={props.showStaffType}
          showTaskType={props.showTaskType}
          showEquipment={props.showEquipment}
          showRounding={props.showRounding}
          showNotes={props.showNotes}
          showGrossHours={props.showGrossHours}
          showLunch={props.showLunch}
          showNetHours={props.showNetHours}
          groupByDay={props.groupByDay}
          expandAll={props.expandAll}
        ></Equipment>
      ))}
    </div>
  );
};

const Equipment = (props) => {
  return (
    <div className={`${row} ${row_site}`}>
      <div className={row_main}>
        <div className={row_col_site_name}>
          <div className={row_title}>Equipment</div>
          <div className={row_value}>{props.name || "-"}</div>
        </div>

        {props.showGrossHours !== false && (
          <div className={row_col_hours}>
            <div className={row_title}>Gross Hours</div>
            <div className={row_value}>
              <DisplayHours hours={Math.round(props.data.total * 100) / 100} />
            </div>
          </div>
        )}

        {props.showLunch !== false && (
          <div className={row_col_hours}>
            <div className={row_title}>Breaks</div>
            <div className={row_value}>
              <DisplayHours hours={Math.round(props.data.lunch * 100) / 100} />
            </div>
          </div>
        )}

        {props.showNetHours !== false && (
          <div className={row_col_hours}>
            <div className={row_title}>Net hours</div>
            <div className={row_value}>
              <DisplayHours
                hours={
                  Math.round((props.data.total - props.data.lunch) * 100) / 100
                }
              />
            </div>
          </div>
        )}

        {props.showRounding && (
          <div className={row_col_hours}>
            <div className={row_title}>Rounded</div>
            <div className={row_value}>
              <DisplayHours hours={props.data.roundedTotal || 0} />
            </div>
          </div>
        )}
      </div>

      <div className={rowsCont}>
        <Hours
          data={props.data.staff}
          siteMode={true}
          showGeolocation={props.showGeolocation}
          showStaffType={props.showStaffType}
          showTaskType={props.showTaskType}
          showEquipment={props.showEquipment}
          showRounding={props.showRounding}
          showNotes={props.showNotes}
          showGrossHours={props.showGrossHours}
          showLunch={props.showLunch}
          showNetHours={props.showNetHours}
          groupByDay={props.groupByDay}
          expandAll={props.expandAll}
        ></Hours>
      </div>
    </div>
  );
};

const Hours = (props) => {
  const data = props.data;
  const range = props.range;
  return (
    <div>
      <div className={rowsCont}>
        {Object.keys(data)
          .map((x, i) => (
            <Row
              hours={data[x]}
              staff={x}
              key={i}
              siteMode={props.siteMode || false}
              showGeolocation={props.showGeolocation}
              showStaffType={props.showStaffType}
              showTaskType={props.showTaskType}
              showEquipment={props.showEquipment}
              showRounding={props.showRounding}
              showNotes={props.showNotes}
              showGrossHours={props.showGrossHours}
              showLunch={props.showLunch}
              showNetHours={props.showNetHours}
              groupByDay={props.groupByDay}
              expandAll={props.expandAll}
            ></Row>
          ))}
      </div>
    </div>
  );
};

const k = (o) => {
  return Object.keys(o);
};

const ki = (o, i) => {
  return k(o).includes(i);
};

function dateRange(inc) {
  const data = [...inc];
  const headers = data[1];
  data.shift();
  data.shift();

  const hasLunch = headers.includes("Lunch Time");
  const newGeo = headers.includes("Start Geolocation");

  let range_start = false;
  let range_end = false;

  let endDateIndex;
  let endTimeIndex;

  if (hasLunch) {
    endDateIndex = 4;
    endTimeIndex = 5;
  } else {
    endDateIndex = 3;
    endTimeIndex = 4;
  }

  data.forEach((x) => {
    if (x.length < 10) {
      return;
    }
    let dateFormat = "ddd D MMM YYYY h:mm a";
    let dateFormat2 = "D-MMM-YYYY h:mm a";

    let mStart = moment(x[1] + " " + x[2], dateFormat);
    let mEnd = moment(x[endDateIndex] + " " + x[endTimeIndex], dateFormat);

    if (!mStart.isValid() || !mEnd.isValid()) {
      mStart = moment(x[1] + " " + x[2], dateFormat2);
      mEnd = moment(x[endDateIndex] + " " + x[endTimeIndex], dateFormat2);
    }

    mStart = mStart.unix();
    mEnd = mEnd.unix();

    if (!range_start || mStart < range_start) {
      range_start = mStart;
    }
    if (!range_end || mEnd > range_end) {
      range_end = mEnd;
    }
  });

  let out = {
    start: moment.unix(range_start).format("ddd DD MMM YYYY"),
    end: moment.unix(range_end).format("ddd DD MMM YYYY"),
  };
  return out;
}

function dateCompare(a, b) {
  const ma = moment(a.start, "ddd D MMM YYYY h:mm a").unix();
  const mb = moment(b.start, "ddd D MMM YYYY h:mm a").unix();

  if (ma < mb) {
    return -1;
  } else if (ma > mb) {
    return 1;
  }
  return 0;
}

function roundToQuarterHour(m) {
  const totalMins = m.hours() * 60 + m.minutes();
  const roundedMins = Math.round(totalMins / 15) * 15;
  return m.clone().startOf("day").add(roundedMins, "minutes");
}

function parseGeo(raw) {
  if (!raw) {
    return ["", ""];
  }

  try {
    const parts = raw.split(",");
    if (!parts || parts.length < 2) {
      return ["", ""];
    }

    const latPart = (parts[0].split(":")[1] || "").trim();
    const lngPart = (parts[1].split(":")[1] || "").trim();

    return [latPart, lngPart];
  } catch {
    return ["", ""];
  }
}

const mapStateToProps = (state) => ({
	timesheetData: state.report?.timesheetData,
	report: state.report,
	siteList: state.sites?.pagination?.results || state.sites?.data || [],
	staffList: state.staff?.pagination?.results || state.staff?.data || [],
	featureFlags: state.featureFlags,
});

const mapDispatchToProps = {
	onFetchData: timesheetReportFetch,
};

export default connect(mapStateToProps, mapDispatchToProps)(TimesheetReport);
